import { DisplayedFile } from 'components/common/gallery/filesStore';
import type { LinkedDocumentationItem } from 'shared/domain/issue/linkedDocumentation';
import type { ExportToDocumentationResultData } from 'shared/domain/issue/linkedDocumentation/operations';
import type { ActionsState } from 'store/types';

export type IssueWithLinkedDocumentation = {
  linkedDocumentation?: LinkedDocumentationItem[];
};

export interface ExportToDocumentationArgs {
  issueId: string;
  fileToExport: DisplayedFile;
  currentDirectoryId: string;
  selectedDirectoryId: string | null;
}

export interface ImportFromDocumentationArgs {
  issueId: string;
  issue: IssueWithLinkedDocumentation | undefined;
  documentationId: string;
  versionId: string;
}

export interface RemoveLinkedDocumentationArgs {
  issueId: string;
  linkedDocumentationId: string;
}

export type { ExportToDocumentationResultData };

export const issueDocumentationOperationNames = [
  'exportToDocumentation',
  'importFromDocumentation',
  'removeLinkedDocumentation',
] as const;

export type IssueDocumentationOperationName =
  (typeof issueDocumentationOperationNames)[number];

export type IssueDocumentationOperationsSlice = {
  _actionStates: ActionsState<IssueDocumentationOperationName>;
  lastError: string | null;
  setLastError: (message: string | null) => void;
  exportToDocumentation: (
    args: ExportToDocumentationArgs
  ) => Promise<ExportToDocumentationResultData>;
  importFromDocumentation: (args: ImportFromDocumentationArgs) => Promise<void>;
  removeLinkedDocumentation: (args: RemoveLinkedDocumentationArgs) => Promise<void>;
  resetIssueDocumentationOperations: () => void;
};
